// Biletele de practică: răspunsurile din sesiunea venită de la server și
// reluarea de unde a rămas elevul. Întrebările fără răspuns au
// selectedAnswer / correctAnswer = null.

/** null / "" nu sunt răspunsuri (Number(null) === 0 le-ar face „prima variantă"). */
export function isEmptyAnswerValue(raw) {
   return raw === null || raw === undefined || String(raw).trim() === "";
}

/* === normalize correct index (0-based) === */
export function normalizeCorrectIdx(raw, answersLen) {
   if (isEmptyAnswerValue(raw)) return null;
   const n = Number(raw);
   if (!Number.isInteger(n) || answersLen <= 0) return null;
   if (n >= 0 && n < answersLen) return n; // 0-based
   if (n >= 1 && n <= answersLen) return n - 1; // 1-based
   return null;
}

export function normalizeSelectedToZeroBased(raw, answersLen) {
   if (isEmptyAnswerValue(raw)) return null;
   const n = Number(raw);
   if (!Number.isInteger(n) || answersLen <= 0) return null;
   if (n >= 0 && n < answersLen) return n; // 0-based
   if (n >= 1 && n <= answersLen) return n - 1; // 1-based
   return null;
}

export function buildPracticeCorrectMap(ticketLike) {
   const out = {};
   const questions = Array.isArray(ticketLike?.questions)
      ? ticketLike.questions
      : [];

   for (const q of questions) {
      const qid = Number(q?.id);
      const serverQid = Number(q?.serverQuestionId ?? q?.questionId ?? q?.id);
      const answersLen = Array.isArray(q?.answers) ? q.answers.length : 0;
      const ci = normalizeCorrectIdx(
         q?.correctAnswer ?? q?.correctIndex ?? q?.rightIndex,
         answersLen,
      );
      if (!Number.isInteger(ci)) continue;

      if (Number.isInteger(qid) && qid > 0) out[qid] = ci;
      if (Number.isInteger(serverQid) && serverQid > 0) out[serverQid] = ci;
   }

   return out;
}

/**
 * Reluare: răspunsurile deja date pe server revin pe ecran, iar elevul
 * continuă de la prima întrebare fără răspuns.
 * questions: întrebările biletului (normalizate, în ordine).
 */
export function buildResumeState(questions = []) {
   const answersMap = {};
   const baselineMap = {};
   for (const q of questions) {
      const answersLen = Array.isArray(q?.answers) ? q.answers.length : 0;
      const selected = normalizeSelectedToZeroBased(q?.selectedAnswer, answersLen);
      if (selected === null) continue;

      const correctIdx = normalizeCorrectIdx(q?.correctAnswer, answersLen);
      answersMap[q.id] = {
         selected,
         correct:
            typeof q?.isCorrect === "boolean"
               ? q.isCorrect
               : Number.isInteger(correctIdx)
                 ? selected === correctIdx
                 : null,
         correctIdx: Number.isInteger(correctIdx) ? correctIdx : null,
         pending: false,
         syncError: false,
      };
      baselineMap[q.id] = selected;
   }
   const firstOpen = questions.findIndex((q) => answersMap[q.id] == null);

   return { answersMap, baselineMap, idx: firstOpen >= 0 ? firstOpen : 0 };
}
